import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageSectionCard } from '../../components/page-section-card/page-section-card';
import { SectionBanner } from '../../components/section-banner/section-banner';
import { SECTORS } from '../../data/sectors.data';

@Component({
  selector: 'app-sectors-page',
  imports: [SectionBanner, PageSectionCard],
  templateUrl: './sectors-page.html',
  styleUrl: './sectors-page.scss',
})
export class SectorsPage {
  sector: any;
  banner: any;
  public slug: any;
  constructor (private route: ActivatedRoute) {
    this.slug = this.route.snapshot.paramMap.get('slug');
    this.sector = SECTORS.find(s => s.slug === this.slug)
    this.banner = {
      bannerTitle: this.sector.name,
      bannerText: this.sector.description,
      bannerImg: this.sector.bannerimg,
      bannerImgMobile: this.sector.bannerImgMobile
    }
    
  }

}
